<template>
  <div>
    <div class="vx-row p-0">
      <div
        @click="SendCategory(category)"
        class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full p-4 m-0"
        style="cursor: pointer"
        v-for="category in categories"
        :key="category.id"
      >
        <div class="titleBar">
          <img
            class="w-full pt-2 pb-2 pr-6 pl-6"
            v-lazy="category.image_thumbnail"
            alt=""
          />
          <p
            class="text-center mt-4"
            style="font-size: 1.2rem; font-weight: 600"
          >
            {{ category.title }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api/api";
import API from "@/api/config";

export default {
  data() {
    return {
      categories: [],
    };
  },
  methods: {
    SendCategory(category) {
      this.$emit("changeCategory", category);
      let params = {};
      params = JSON.parse(JSON.stringify(this.$route.query));
      params.category = category.id;
      this.$router.push({ query: params }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    GetCategories() {
      this.$vs.loading({ text: this.$t("Loading_Please_Wait") });
      Api.get(
        API.BASEURL + API.NOKTA_MARKET_CATEGORIES,
        this.HandleGetCategories
      );
    },
    HandleGetCategories(status, data) {
      this.$vs.loading.close();
      if (status == 200) {
        this.categories = data;
        if (this.$route.query.category != null) {
          let index = this.categories.findIndex(
            (e) => e.id == this.$route.query.category
          );
          this.SendCategory(this.categories[index]);
        }
      }
    },
  },
  computed: {
    noktaMarketPermission() {
      return this.$store.getters.getNoktaMarketPermission;
    },
  },
  created() {
    if (this.noktaMarketPermission) {
      this.GetCategories();
    } else {
      this.$router.push({ name: "machines" });
    }
  },
};
</script>

<style>
.titleBar {
  background-color: #fff;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
</style>
